<template>
  <!-- Modal Bootstrap -->
  <div class="modal fade" ref="modal" id="seleccionarClienteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Seleccionar Cliente</h4>
          <button type="button" class="btn-close" @click="cerrarModal"></button>
        </div>
        <div class="modal-body">
          <!-- Spinner de carga -->
          <div v-if="cargando" class="d-flex justify-content-center align-items-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <span class="ml-2">Cargando clientes...</span>
          </div>

          <div v-else>
          <!-- Select2 para Clientes Frecuentes -->
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Clientes Frecuentes</label>
            <div class="col-sm-9">
              <select ref="selectCliente" class="form-control select2" v-model="selectedCliente">
                <option value="">Seleccionar Cliente</option>
                <option v-for="cliente in clientesActivos" :key="cliente.id" :value="cliente.id">
                  {{ cliente.nombre }}
                </option>
              </select>
            </div>
          </div>

          <!-- Campos del cliente -->
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Código</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.codigo" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Nombre / Negocio</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.nombre" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Encargado</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.encargado" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">RIF / C.I</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.rif" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Email</label>
            <div class="col-sm-9">
              <input type="email" class="form-control" v-model="form.email" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Teléfono</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.telefono" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Dirección</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="form.direccion" :disabled="!isClienteOcasional">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Tipo de Contribuyente</label>
            <div class="col-sm-9">
              <select class="form-control" v-model="form.tipo_contribuyente" :disabled="!isClienteOcasional">
                <option disabled value="">Seleccione un tipo</option>
                <option value="ordinario">Contribuyente Ordinario</option>
                <option value="especial">Contribuyente Especial</option>
              </select>
            </div>
          </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-secondary" @click="limpiarCampos">Limpiar</button>
          <button type="button" class="btn btn-primary" @click="emitirSeleccion">Seleccionar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { Modal } from "bootstrap";

export default {
  name: "SeleccionarClienteModal",
  data() {
    return {
      form: {
        codigo: "",
        nombre: "",
        encargado: "",
        rif: "",
        email: "",
        telefono: "",
        direccion: "",
        tipo_contribuyente: ""
      },
      selectedCliente: "",
      clientesFrecuentes: [],
      cargando: false
    };
  },
  computed: {
    isClienteOcasional() {
      return this.selectedCliente === "ocasional";
    },
    clientesActivos() {
      return this.clientesFrecuentes.filter(cliente => cliente.estatus !== 0);
    }
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.modal);
    this.cargarClientesFrecuentes();
    this.inicializarSelect2();
  },
  methods: {
    abrirModal() {
      this.modalInstance.show();
    },
    cerrarModal() {
      this.modalInstance.hide();
    },
    async cargarClientesFrecuentes() {
      try {
        this.cargando = true;
        const response = await api.get("/clientes");
        this.clientesFrecuentes = response.data;
        this.inicializarSelect2();
      } catch (error) {
        console.error("Error cargando clientes frecuentes:", error);
      } finally {
        this.cargando = false;
      }
    },
    inicializarSelect2() {
      this.$nextTick(() => {
        import("select2").then(() => {
          $(this.$refs.selectCliente).select2({
            theme: "bootstrap4",
            placeholder: "Selecciona o escribe un cliente",
            dropdownParent: $(this.$refs.modal),
            allowClear: true,
            tags: true,
            minimumResultsForSearch: 0,
          });

          $(this.$refs.selectCliente).on("change", () => {
            this.selectedCliente = $(this.$refs.selectCliente).val();
            this.seleccionarCliente();
          });
        });
      });
    },
    limpiarCampos() {
      this.form = {
        codigo: "",
        nombre: "",
        encargado: "",
        rif: "",
        email: "",
        telefono: "",
        direccion: "",
        tipo_contribuyente: ""
      };
      this.selectedCliente = "";
    },
    seleccionarCliente() {
      if (this.selectedCliente && this.selectedCliente !== "ocasional") {
        const cliente = this.clientesFrecuentes.find(c => c.id == this.selectedCliente);
        if (cliente) {
          this.form = { ...cliente };
        }
      } else {
        this.form = {
          codigo: "",
          nombre: "",
          encargado: "",
          rif: "",
          email: "",
          telefono: "",
          direccion: "",
          tipo_contribuyente: ""
        };
      }
    },
    emitirSeleccion() {
      this.$emit("cliente-seleccionado", { ...this.form });
      this.cerrarModal();
    }
  }
};
</script>
<style scoped>
.modal-body { max-height: 60vh; overflow-y: auto; }
</style>